import type { PropsWithChildren } from "react";
import { cn } from "@/lib/cn";

interface BadgeProps extends PropsWithChildren {
  tone?: "gold" | "wine" | "moss";
  className?: string;
}

const toneMap = {
  gold: "border-gold/35 bg-gold/10 text-gold",
  wine: "border-wine/40 bg-wine/15 text-[#f1c3c3]",
  moss: "border-moss/40 bg-moss/15 text-[#caddb8]"
};

export function Badge({ children, tone = "gold", className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-3 py-1 text-xs uppercase tracking-[0.18em]",
        toneMap[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
